import React from "react";
import { Grid } from "@material-ui/core";

import { Header, Cell } from "./";
import "./styles.css";

const ProceedsCard = ({ term, lenderProceeds, favoritedTerms = [], dealId, refiAnalysisType }) => (
  <Grid item xs={6} className="proceeds-card-grid-container">
    <Grid container item className="proceeds-card-header-wrapper">
      <Header dealId={dealId} favorited={favoritedTerms.includes(parseInt(term))} term={term} />
    </Grid>
    {lenderProceeds?.filter(proceed => proceed.cashout).map((proceeds, idx) => <Grid item key={idx}><Cell refiAnalysisType={refiAnalysisType} dealId={dealId} {...proceeds} /></Grid>)}
  </Grid>
);

export default ProceedsCard;
